<template>
  <div>
    <div class="main-wrapper">
      <sidebar-component />
      <div class="page-wrapper">
        <navbar-component />
        <div class="page-content">
          <div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">
            <div>
              <h4 class="mb-3 mb-md-0">Add Information Event</h4>
            </div>
            <div class="d-flex align-items-center flex-wrap text-nowrap">
              <router-link :to="{ name: 'InformationEventsIndex' }" class="btn btn-secondary mb-2 mb-md-0">
                Back to List
              </router-link>
            </div>
          </div>

          <div class="row">
            <div class="col-12 stretch-card">
              <div class="card">
                <div class="card-body">
                  <h6 class="card-title">Event Information</h6>
                  <form @submit.prevent="submitData" class="forms-sample">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="name" class="form-label">Event Name *</label>
                          <input 
                            type="text" 
                            class="form-control" 
                            id="name" 
                            v-model="forms.name" 
                            placeholder="Enter event name"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="link_event" class="form-label">Event Link</label>
                          <input 
                            type="url" 
                            class="form-control" 
                            id="link_event" 
                            v-model="forms.link_event" 
                            placeholder="https://example.com/event"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="mb-3">
                      <label for="description" class="form-label">Description</label>
                      <textarea 
                        class="form-control" 
                        id="description" 
                        rows="4" 
                        v-model="forms.description" 
                        placeholder="Enter event description"
                      ></textarea>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="start_date" class="form-label">Start Date *</label>
                          <input 
                            type="datetime-local" 
                            class="form-control" 
                            id="start_date" 
                            v-model="forms.start_date" 
                            required
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="end_date" class="form-label">End Date *</label>
                          <input 
                            type="datetime-local" 
                            class="form-control" 
                            id="end_date" 
                            v-model="forms.end_date" 
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3">
                          <label for="image" class="form-label">Event Image</label>
                          <input 
                            type="file" 
                            class="form-control" 
                            id="image" 
                            @change="handleImageChange"
                            accept="image/*"
                          />
                          <small class="form-text text-muted">
                            Supported formats: JPEG, PNG, JPG, GIF. Max size: 2MB
                          </small>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="mb-3">
                          <div class="form-check form-switch">
                            <input 
                              class="form-check-input" 
                              type="checkbox" 
                              id="is_active" 
                              v-model="forms.is_active"
                            />
                            <label class="form-check-label" for="is_active">
                              Active Event
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Image Preview -->
                    <div v-if="imagePreview" class="mb-3">
                      <label class="form-label">Image Preview</label>
                      <div>
                        <img 
                          :src="imagePreview" 
                          alt="Preview" 
                          style="max-width: 300px; max-height: 200px; object-fit: cover; border-radius: 8px;"
                        />
                      </div>
                    </div>

                    <div class="d-flex justify-content-end">
                      <router-link :to="{ name: 'InformationEventsIndex' }" class="btn btn-secondary me-2">
                        Cancel
                      </router-link>
                      <button type="submit" class="btn btn-primary" :disabled="isLoading">
                        <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        {{ isLoading ? 'Creating...' : 'Create Event' }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer-component />
      </div>
    </div>
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
  name: "InformationEventsAdd",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
  },
  data() {
    return {
      isLoading: false,
      imagePreview: null,
      forms: {
        name: '',
        description: '',
        image: null,
        start_date: '',
        end_date: '',
        link_event: '',
        is_active: true
      },
      errors: []
    };
  },
  methods: {
    handleImageChange(event) {
      const file = event.target.files[0];
      if (file) {
        // Validate file type
        if (!file.type.startsWith('image/')) {
          this.$swal('Error', 'Please select an image file', 'error');
          return;
        }
        
        // Validate file size (2MB)
        if (file.size > 2 * 1024 * 1024) {
          this.$swal('Error', 'Image size must be less than 2MB', 'error');
          return;
        }
        
        this.forms.image = file;
        
        // Create preview
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imagePreview = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },

    submitData() {
      // Validate dates
      if (new Date(this.forms.start_date) >= new Date(this.forms.end_date)) {
        this.$swal('Error', 'End date must be after start date', 'error');
        return;
      }

      this.isLoading = true;
      
      let formData = new FormData();
      formData.append("name", this.forms.name);
      formData.append("description", this.forms.description || '');
      formData.append("start_date", this.forms.start_date);
      formData.append("end_date", this.forms.end_date);
      formData.append("link_event", this.forms.link_event || '');
      formData.append("is_active", this.forms.is_active ? 1 : 0);
      
      if (this.forms.image) {
        formData.append("image", this.forms.image);
      }

      const baseURI = this.$settings.endPoint + "information-events/create";
      
      this.$http
        .post(baseURI, formData, {
          timeout: 30000,
          headers: {
            'AppToken': this.$settings.jwtSecret,
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((response) => {
          this.isLoading = false;
          if (response.data.status === 200) {
            this.$swal('Success', 'Information event created successfully', 'success');
            this.resetForm();
            this.$router.push({ name: 'InformationEventsIndex' });
          } else {
            this.handleErrors(response.data.errors);
          }
        })
        .catch(error => {
          this.isLoading = false;
          this.handleError(error);
        });
    },

    resetForm() {
      this.forms = {
        name: '',
        description: '',
        image: null,
        start_date: '',
        end_date: '',
        link_event: '',
        is_active: true
      };
      this.imagePreview = null;
      this.errors = [];
    },

    handleErrors(errors) {
      this.errors = errors;
      if (errors) {
        let errorMessages = [];
        Object.keys(errors).forEach(key => {
          if (errors[key] && errors[key].length > 0) {
            errorMessages.push(errors[key][0]);
          }
        });
        if (errorMessages.length > 0) {
          this.$swal('Validation Error', errorMessages.join('<br>'), 'error');
        }
      }
    },

    handleError(error) {
      if (error.response) {
        if (error.response.status === 422) {
          this.handleErrors(error.response.data.errors);
        } else if (error.response.status === 500) {
          this.$swal('Error', 'Internal server error', 'error');
        } else if (error.response.status === 401) {
          this.$router.push("/authorized-error");
        } else {
          this.$swal('Error', 'An error occurred', 'error');
        }
      } else {
        this.$swal('Error', 'Network error occurred', 'error');
      }
    }
  }
};
</script>

<style scoped>
.forms-sample .form-control:focus {
  border-color: #6571ff;
  box-shadow: 0 0 0 0.2rem rgba(101, 113, 255, 0.25);
}

.card {
  box-shadow: 0 0 1rem 0 rgba(136, 152, 170, 0.15);
}

.btn {
  margin-left: 0.5rem;
}

.btn:first-child {
  margin-left: 0;
}
</style>